const HELP_TEXTS = {
  tooltips: {
    budgetSplit:
      'Quarterly and business splits will be used for the steering of the agreement “Open Budget”. Relevant quarters are automatically displayed based on the agreement’s timeframe and their shares’ configuration is optional. Business splits are mandatory and pre-configured with defaults. All splits can be changed at any time. There is no synchronisation between these splits and the related opportunities.',
  },
};

export default HELP_TEXTS;
